import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Question } from '../../components/Question';
import { withScreenshot } from '../../hocs/withScreenshot';

class QuestionContainer extends Component {
  constructor(props) {
    super(props);

    this.onContinue = this.onContinue.bind(this);
    this.screenshotCaptureCallback = this.screenshotCaptureCallback.bind(this);

    this.state = {
      selectedAnswer: null,
      hasError: false,
      isLoading: false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.question !== this.props.question) {
      // if the question has changed, reset it's answer to null
      this.setState(() => {
        return { selectedAnswer: null };
      });
    } else if (prevProps.screenshot !== this.props.screenshot) {
      // call onAnswerSelected providing the currently selected answer + new screenshot
      this.props.onAnswerSelected(this.state.selectedAnswer, this.props.screenshot);
    }
  }

  screenshotCaptureCallback() {
    this.setState(() => {
      return { isLoading: false };
    });
  }

  onContinue() {
    if (this.state.selectedAnswer) {
      // prevent double-clicking by passing an isLoading flag to the Question Component, disabling Continue
      this.setState(
        () => {
          return { isLoading: true };
        },
        () => this.props.onCaptureScreenshot(this.screenshotCaptureCallback)
      );
    } else {
      this.setState({ hasError: true });
    }
  }

  render() {
    const {
      question: { question, answers },
      currentQuestionIndex
    } = this.props;
    const { selectedAnswer, hasError } = this.state;

    return (
      <Question
        onAnswerSelected={newAnswer => {
          this.setState(() => {
            return { selectedAnswer: newAnswer, hasError: false };
          });
        }}
        hasError={hasError}
        selectedAnswer={selectedAnswer}
        onContinue={this.onContinue}
        questionText={question}
        answers={answers}
        isLoading={this.state.isLoading}
        currentQuestionIndex={currentQuestionIndex}
      />
    );
  }
}

QuestionContainer.propTypes = {
  onAnswerSelected: PropTypes.func.isRequired,
  onCaptureScreenshot: PropTypes.func.isRequired,
  screenshot: PropTypes.string,
  question: PropTypes.object.isRequired
};

QuestionContainer.defaultProps = {
  screenshot: null
};

const ConnectedQuestionContainer = withScreenshot()(QuestionContainer);

export { ConnectedQuestionContainer as QuestionContainer };
